import { render, staticRenderFns } from "./DeliveryOrderInfo.vue?vue&type=template&id=30e15735&"
import script from "./DeliveryOrderInfo.vue?vue&type=script&lang=js&"
export * from "./DeliveryOrderInfo.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryOrderInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports